import React from "react";
import {DefaultDataGridState} from "../Types/DefaultDataGridState";
import Column from "./Column";
import {GUIProps} from "./Types/GUIProps";

const width = (child) => {
    const width = child.props.width === "auto" ? 0 : (child.props.width || 1);
    return !isNaN(width) ? Number(width) : 1;
}

export default class Header extends React.Component<GUIProps, DefaultDataGridState> {
    render() {
        if (this.props.headers === false) return null;
        const fields = this.props.getFields({onlyVisible: true});
        let full = fields.reduce((sum, child) => {
            return sum + width(child);
        }, 0);
        return (
            <thead className="p-datatable-thead">
                <tr>
                    {
                        fields.map((child, idx) => {
                            return (
                                <Column
                                    key={idx}
                                    calculatedColumnWidth={child.props.width !== "auto" ? (Math.round((100 / full * width(child)) * 100) / 100) : undefined}
                                    state={this.props.columnState[child.props.field] || {}}
                                    changeOrder={(order, meta, cb) => {
                                        this.props.setColumnState({
                                            field: child.props.field,
                                            state: {order},
                                            meta,
                                            cb
                                        });
                                    }}
                                    setState={(state, cb) => {
                                        this.props.setColumnState({
                                            field: child.props.field,
                                            state,
                                            cb
                                        });
                                    }}
                                    {...this.props}
                                    {...child.props}
                                >
                                    {child.props.children}
                                </Column>
                            );
                        })
                    }
                </tr>
            </thead>
        );
    }
}